import { render } from "./basic.vue?vue&type=template&id=1b3e3d9a"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__